export const CONTABLE_DASHBOARD_FETCH_REQUEST = "CONTABLE_DASHBOARD_FETCH_REQUEST";
export const CONTABLE_DASHBOARD_FETCH_SUCCESS = "CONTABLE_DASHBOARD_FETCH_SUCCESS";
export const CONTABLE_DASHBOARD_FETCH_FAILURE = "CONTABLE_DASHBOARD_FETCH_FAILURE";
export const CONTABLE_DASHBOARD_FETCH_RESET = "CONTABLE_DASHBOARD_FETCH_RESET";
